import { CustomColumnGridConfig } from '../types'

const columnsConfig: CustomColumnGridConfig[] = [
  // מספר משלם → payerNumber
  {
    width: 150,
    minWidth: 150,
    flex: 1,
    field: 'propertyNumber',
    headerName: 'מספר משלם',
    hideable: true,
    disableAggregation: true,
    filterSpec: { kind: 'text' },
    filterable: true,
  },
  // שם צרכן → name
  {
    width: 150,
    minWidth: 150,
    flex: 1,
    field: 'name',
    headerName: 'שם צרכן',
    hideable: true,
    disableAggregation: true,
    filterSpec: { kind: 'text' },
    filterable: true,
  },
  // כתובת → address
  {
    width: 150,
    minWidth: 150,
    flex: 1,
    field: 'address',
    headerName: 'כתובת',
    hideable: true,
    disableAggregation: true,
    filterSpec: { kind: 'text' },
    filterable: true,
  },
  // דוא"ל → email
  {
    width: 150,
    minWidth: 150,
    flex: 1,
    field: 'email',
    headerName: 'דוא״ל',
    hideable: true,
    disableAggregation: true,
    filterSpec: { kind: 'text' },
    filterable: true,
  },
  // מספר טלפון → phone
  {
    width: 150,
    minWidth: 150,
    flex: 1,
    field: 'phone',
    headerName: 'מספר טלפון',
    hideable: true,
    disableAggregation: true,
    filterSpec: { kind: 'text' },
    filterable: true,
  },
  // סוג שימוש → usageType  (add to rows)
  {
    width: 150,
    minWidth: 150,
    flex: 1,
    field: 'usageType',
    headerName: 'סוג שימוש',
    hideable: true,
    disableAggregation: true,
    filterSpec: { kind: 'list', options: { source: 'rows' } },
    filterable: true,
  },
  // מספר נפשות → householdSize  (add to rows)
  {
    width: 150,
    minWidth: 150,
    flex: 1,
    field: 'householdSize',
    headerName: 'מספר נפשות',
    hideable: true,
    disableAggregation: true,
    filterSpec: { kind: 'number' },
    filterable: true,
  },
]

export default columnsConfig
